import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import ar from "./locales/ar.json";
import tr from "./locales/tr.json";
import it from "./locales/it.json";
import uk from "./locales/uk.json";
import ru from "./locales/ru.json";

const savedLanguage = localStorage.getItem("appLanguage") || "de"; // Load language

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      ar: { translation: ar },
      tr: { translation: tr },
      it: { translation: it },
      uk: { translation: uk },
      ru: { translation: ru },
    },
    lng: savedLanguage, // Set initial language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    postProcess: ['capitalize']
  });

i18n.use({
  type: 'postProcessor',
  name: 'capitalize',
  process: (value) =>
    value.charAt(0).toUpperCase() + value.slice(1),
});

export default i18n;
